import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const Header = styled.div`
    width: 248px;
    height: 100%;
    overflow: hidden;
    color: white;
`;

export const StyledLink = styled.a`
    color: ${(props) => props.theme.white} !important
`;

export const Logo = styled.div`
    height: 40px;
    margin: 24px auto;
`;

export const MenuItemTitle = styled.span`
`;

export const MenuList = styled.ul`
    list-style-type: "none";
    padding: 0;
    overflow: auto;

    & li a:first-child{
        color: ${(props) => props.theme.whiteLink} !important;
    }
    
    &.sub-menu {
        max-height: 0px;
        transform: scaleY(0);
        transform-origin: top left;
        overflow: hidden;
        &.open {
            max-height: 500px;
            transform: scaleY(1);
        }
    }

    .menu-item {
        display: flex;
        align-items: center;
        height: 44px;
        margin: 4px 10px;
        padding: 0 6px;
        border-radius: 8px;
        text-align: left;
        font-size: ${theme.font.size14};
        font-weight: bold;
        text-decoration: none;
        cursor: pointer;


        &.disabled-item {
            opacity: 0.2;
            cursor: not-allowed;

            & *::selection { background: transparent; } 
            & *::-moz-selection { background: transparent; }
        }

        &:not(.disabled-item) {       
            :hover,
            :active,
            :focus,
            &.active {
                background: ${(props) => props.theme.white20};
            }
        }

        &.sub-item {
            font-weight: normal;
            height: auto;
            margin: 14px 16px;
            color: ${(props) => props.theme.whiteLink} !important;
            
            :hover,
            :active,
            :focus,
            &.active {
                background: transparent;
                color: ${(props) => props.theme.orangeLink} !important;
                text-decoration: underline ${(props) => props.theme.orangeLink} !important;
            }
        }
    }
`;

